/**
 * @fileoverview Mixin del Centro de Ayuda con el estado de navegación: los 3 pasos (productos, temas y
 * preguntas), lo que muestra el breadcrumb y si el dispositivo es móvil (se detecta una sola vez, por user agent).
 * @module mixins/help-center-navigation.mixin
 */

import { isMobileDevice } from '@/utils/device'

export default {
  data () {
    return {
      step1: true,
      step2: false,
      step3: false,
      productShow: false,
      menuShow: false,
      menuActive: '',
      mobile: isMobileDevice()
    }
  },
  methods: {
    /** Vuelve al paso 1: lista de productos. */
    goHome () {
      this.step1 = true
      this.step2 = false
      this.step3 = false
      this.productShow = false
      this.menuShow = false
    },

    /** Vuelve al paso 2: temas del producto activo. */
    goProduct () {
      this.step1 = false
      this.step2 = true
      this.step3 = false
      this.menuShow = false
    },

    /** Muestra los temas del producto abierto (paso 2). */
    goTopics () {
      this.step1 = false
      this.step2 = true
      this.productShow = true
    },

    /**
     * Muestra las preguntas de un tema (paso 3). En móvil reemplazan a la lista de temas y el breadcrumb las nombra.
     * @param {string} topicName - Nombre del tema abierto
     */
    goQuestions (topicName) {
      this.step1 = false
      this.step3 = true
      if (this.mobile) {
        this.menuActive = topicName
        this.step2 = false
        this.menuShow = true
      } else {
        this.step2 = true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/help-center-navigation.mixin.js